import { _decorator } from 'cc';
import StateContext from '../../../../common/scripts/Toolkit/Architecture/StateSynchronization/StateContext';
import OptionValuePicker from '../../../../common/scripts/Toolkit/Components/ValuePicker/OptionValuePicker';
import TableGame from '../../System/TableGame';
import TableModel from '../Data/Model/TableModel';

const { ccclass } = _decorator;

@ccclass('GameContext')
export default abstract class GameContext extends StateContext {
    protected static contextMap: {
        [tableID: string]: GameContext;
    } = {};

    protected _betValueSelector: OptionValuePicker = null;

    public static get currentContext() {
        return this.contextMap[TableGame.currentTable?.tableID];
    }

    public get model(): TableModel {
        return super.model as TableModel;
    }

    public set model(value: TableModel) {
        super.model = value;
    }

    public get betValueSelector() {
        return this._betValueSelector;
    }
    public set betValueSelector(selector: OptionValuePicker) {
        if (this._betValueSelector === selector) {
            return;
        }
        this._betValueSelector = selector;
    }

    public onEnable() {
        this.model = TableGame.currentTable;
        super.onEnable();
    }
    public onDisable() {
        super.onDisable();
        this.model = null;
    }

    protected attachStateModel(model: TableModel) {
        // 用到 model 就要繼承 StateContextDependObject
        GameContext.contextMap[model.tableID] = this;
        super.attachStateModel(model);
        this.initStateGraph();
    }

    protected detachStateModel() {
        super.detachStateModel();
        if (!this.model) {
            return;
        }
        if (GameContext.contextMap[this.model.tableID] === this) {
            GameContext.contextMap[this.model.tableID] = null;
        }
    }

    protected onContextReset(): void {
        super.onContextReset();
        TableGame.audio.stopAllEffects();
    }

    public abstract initStateGraph(): void;
}
